import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InitializerService } from '../initializer.service';
import { urlApi } from '../utils/apiConfig';

@Injectable()
export class PagarmeService {

  constructor(private http: HttpClient) {

   }

  public getQrCode(email:string): Observable<any>{
    return this.http.post(`${urlApi}/pagar/criar`,{email})
  }

  public getAddress(cep: string): Observable<any>{
    return this.http.get(`https://viacep.com.br/ws/${cep}/json/`);
  }

  public sendAssign(dataCard: any): Observable<any>{
    return this.http.post(`${urlApi}/pagar/criar/assinatura`, dataCard);
  }
}
